/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCoinYuan = createReactComponent("coin-yuan", "IconCoinYuan", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 13h6", key: "svg-1" }],
  ["path", { d: "M9 8l3 4.5", key: "svg-2" }],
  ["path", { d: "M15 8l-3 4.5v4.5", key: "svg-3" }]
]);

export { IconCoinYuan as default };
//# sourceMappingURL=IconCoinYuan.js.map
